@use 'sass:map';

@use '../../../scss/global/spacing';

@use './loader.vars.scss' as *;
@use './loader.mixins.scss' as mixins;

:host {
  display: flex;

  .fds-loader__spinner {
    width: 1rem;
    height: 1rem;
    color: var(--spinner-color-default);

    @include mixins.loader-border;
    @include mixins.loader-animation;
  }
}
